import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { setupEndPoints } from '@/config/axiosConfig'
import router from '@/router'

import * as Sentry from '@sentry/vue'

// Plugins
import i18n from '@/plugins/i18n'
import plantarEducacao from '@/plugins/peComponents'
import { vMaska } from 'maska/vue'
import { createVfm } from 'vue-final-modal'
import datePicker from '@vuepic/vue-datepicker'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import { MotionPlugin } from '@vueuse/motion'
import VueEasyLightbox from 'vue-easy-lightbox'

import 'vue-final-modal/style.css'
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'
import '@vuepic/vue-datepicker/dist/main.css'


// Toast UI Editor base
import '@toast-ui/editor/dist/toastui-editor.css'

// Idiomas
import '@toast-ui/editor/dist/i18n/pt-br'
import '@toast-ui/editor/dist/i18n/es-es'

// Tema do editor
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';

// Viewer (somente se for usar a visualização)
import '@toast-ui/editor/dist/toastui-editor-viewer.css'

// Plugins e seus estilos
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css'
import '@toast-ui/editor-plugin-table-merged-cell/dist/toastui-editor-plugin-table-merged-cell.css'

// Vue3ColorPicker
import '@cyhnkckali/vue3-color-picker/dist/style.css'

import App from './App.vue'

// Folha de estilos padrão
import '@/styles/app.scss'

// Icones (Material Symbols)
import 'material-symbols'
import storeReset from './stores/plugin/resetStore'

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement
} from 'chart.js'

// Custom Directives
import uiTooltip from '@/directives/tooltip'

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement
)

const app = createApp(App)

const pinia = createPinia()
pinia.use(storeReset)

const vfm = createVfm()

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    app,
    dsn: "https://16b7ce8f1b422caddc32fcea3b78f728@o4509010095243264.ingest.us.sentry.io/4509010439503872",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'https://app.plantareducacao.com.br/api/'
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

app
  .use(i18n)
  .use(router)
  .use(pinia)
  .use(plantarEducacao)
  .use(vfm)
  .use(autoAnimatePlugin)
  .use(MotionPlugin)
  .use(VueEasyLightbox)
  .component('DatePicker', datePicker)
  .directive('maska', vMaska as any)
  .directive('tooltip', uiTooltip)

// Isso aqui deve vir após a definição do pinia, e antes do app.mount pois alguns componentes dependem do de comunicação via axios
setupEndPoints()

app.mount('#app')

// current version
const cv = localStorage.getItem('v')
import { version } from './version'

if (!version || !cv || version !== cv) {
  console.log('Atualizando versão do app')
  localStorage.clear()
  sessionStorage.clear()

  localStorage.setItem('v', version)
  caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))))
  window.location.reload()
}
